// web_components/wcRafModal/wcRafModal_Renderer.ts

/**
 * Generates the HTML for the wc-raf-modal component.
 * Handles CSS, variables, etc.
 *
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(instanceId: string): string {
	// Initialize styleTag to an empty string
	let styleTag = '';

	return `
        ${styleTag}
        <div id="${instanceId}" class="wc-raf-modal modal-active modal-transition" role="dialog" aria-labelledby="rafModalTitle" aria-describedby="rafModalDescription" aria-modal="true" tabindex="-1">
        	<div class="wc-modal__overlay"><i></i></div>
            <div class="wc-modal__dialog">
				<button class="wc-modal__close" type="button" aria-label="Close modal"><i></i></button>
				<div class="wc-raf-modal__container">
					<article>
						<h2>Get &pound;${window.serverData?.rafReward} on your account</h2>
						<p>
							<strong>${window.serverData?.customerFirstName}</strong>, give your friends ${window.serverData?.storeName == 'Virgin Wines' ? 'at least &pound;40' : '&pound;25'} off their first order with us by sharing your unique link, and when they buy you'll get &pound;${window.serverData?.rafReward} credit applied to your account. ${window.serverData?.storeName == 'Virgin Wines' ? '' : 'Cheers!'}
						 	<p> <a href="${window.serverData?.contextPath}/account/referAFriend"/>Terms and conditions</a> apply.</p>
						</p>
					</article>
					<section>
						<p><b>Share your link:</b></p>
						<div>
							<p class="wc-raf-modal__link">www.${window.serverData?.storeName == 'Virgin Wines' ? 'virginwines' : 'warehousewines'}.co.uk<wbr>/raf/${window.serverData?.referAFriendCode}</p>
							<div>
								<a class="wc-raf-modal__btn" href="#">Copy</a>
							</div>
						</div>
						<p><b>Or share via:</b></p>
						<div>
							<a 
								class="wc-raf-modal__btn wc-raf-modal__btn-email"
								target="_self" 
								href="mailto:?&subject=Thought%20you%20might%20like%20this%3A%20${window.serverData?.storeName == 'Virgin Wines' ? 'at%20least%20%C2%A340%20off%20at%20Virgin%20Wines' : '&pound;25%20off%20your%20first%20order%20at%20Warehouse%20Wines%20-%20wines%20from%20just%20&pound;5.74%20a%20bottle!'}%0A&body=I%20recently%20used%20${window.serverData?.storeName}%20and%20they%20gave%20me%20a%20special%20offer%20to%20share%20with%20my%20friends.%20%0A%0DI%E2%80%99m%20treating%20you%20to%20${window.serverData?.storeName == 'Virgin Wines' ? 'an%20exclusive%20case%20of%20wine%20with%20a%20minimum%20discount%20of%20at%20least%20%C2%A340.' : 'a%20&pound;25%20voucher%20to%20use%20against%20your%20first%20order,%20get%20a%20case%20for%20as%20little%20as%20&pound;5.74%20a%20bottle!'} %20%0A%0DI%E2%80%99ll%20also%20get%20a%20reward,%20so%20it%E2%80%99s%20win-win!%20%20%0A%0D%0A%0Dhttp://www.${window.serverData?.storeName == 'Virgin Wines' ? 'virginwines' : 'warehousewines'}.co.uk/raf/${window.serverData?.referAFriendCode}%20%20%0A%0D%0A%0DIf%20you%20don%E2%80%99t%20want%20me%20to%20send%20you%20this%20type%20of%20offer,%20just%20let%20me%20know."
								>
								Email
							</a>
							<a 
								class="wc-raf-modal__btn wc-raf-modal__btn-whatsapp"
								target="_blank" 
								href="${
									window.serverData?.storeName == 'Virgin Wines'
										? `https://api.whatsapp.com/send?phone=&text=I%20recently%20used%20Virgin%20Wines%20and%20they%20gave%20me%20a%20special%20offer%20to%20share%20with%20my%20friends.%20%0A%0DI%E2%80%99m%20treating%20you%20to%20an%20exclusive%20case%20of%20wine%20with%20a%20minimum%20discount%20of%20at%20least%20%C2%A340.%20%0A%0DI%E2%80%99ll%20also%20get%20a%20reward,%20so%20it%E2%80%99s%20win-win!%20%20%0A%0D%0A%0Dhttp://www.virginwines.co.uk/raf/${window.serverData?.referAFriendCode}%20%20%0A%0D%0A%0DIf%20you%20don%E2%80%99t%20want%20me%20to%20send%20you%20this%20type%20of%20offer,%20just%20let%20me%20know.\n`
										: `https://api.whatsapp.com/send?phone=&text=Get%20&pound;25%20off%20your%20first%20order%20at%20Warehouse%20Wines with%20my%20special%20referral%20link.%20Find%20out%20more%20here%20-%20https://www.warehousewines.co.uk/raf/${window.serverData?.referAFriendCode}`
								}">
								WhatsApp
							</a>
						</div>
					</section>
				</div>
            </div>
        </div>
    `;
}
